<div class="employer-contact-card">
  <button
    type="button"
    class="no-style-button text-start w-100"
    [attr.aria-expanded]="!isCollapsed"
    [attr.aria-controls]="'contactReviewGrid-' + contact?.id"
    (click)="toggle.emit()">
    <div class="d-flex gap-4 align-items-center">
      <div class="d-flex flex-column gap-3 flex-grow-1">
        <div class="contact-name">{{ contact?.firstName }} {{ contact?.lastName }}</div>
        <div *ngIf="contact?.hasSigningAuthority" class="d-flex align-items-center gap-2">
          <img
            src="assets/icons/green/CheckCircle.svg"
            alt=""
            aria-hidden="true"
            [style.height.rem]="1.25"
            [style.width.rem]="1.25" />
          <span class="fw-medium" i18n>Has Signing Authority</span>
        </div>
      </div>
      <div class="flex-shrink-0">
        <img
          src="assets/icons/grey/Chevron%20Down.svg"
          alt=""
          height="24"
          width="24"
          class="chevron-svg"
          aria-hidden="true"
          [class.rotated]="!isCollapsed" />
      </div>
    </div>
  </button>
  <div [id]="'contactReviewGrid-' + contact?.id" [ngbCollapse]="isCollapsed">
    <div
      class="collapsible-inner-content"
      role="region"
      [attr.aria-label]="contact?.firstName + ' ' + contact?.lastName + ' contact details'">
      <div class="review-entry-grid">
        <app-review-entry label="Job Title" i18n-label [value]="contact?.jobTitle" />
        <app-review-entry
          *ngIf="contact?.contactTopic"
          label="Contact Topic"
          i18n-label
          [value]="contact.contactTopic" />
        <app-review-entry label="Work Email Address" i18n-label [value]="contact?.email" />
        <app-review-entry
          *ngIf="contact?.phoneNumber"
          label="Primary Phone Number"
          i18n-label
          [value]="contact?.phoneNumber | formattedPhoneNumber : contact?.phoneNumberCountryCode" />
      </div>
      <div class="review-entry-grid" *ngIf="contact?.address">
        <app-review-entry label="Country" i18n-label [value]="contact?.address?.country?.name" />
        <app-review-entry label="Address Line 1" i18n-label [value]="contact?.address?.addressLine1" />
        <app-review-entry label="Address Line 2" i18n-label [value]="contact?.address?.addressLine2" />
        <app-review-entry label="Address Line 3" i18n-label [value]="contact?.address?.addressLine3" />
        <app-review-entry label="City/Town" i18n-label [value]="contact?.address?.city" />
        <app-review-entry label="Province/State/Region" i18n-label [value]="contact?.address?.state?.name" />
        <app-review-entry label="Postal Code/ZIP" i18n-label [value]="contact?.address?.postalCode" />
      </div>
    </div>
  </div>
</div>
